<template>
    <div class="col-sm-12 list-container nopads">
        <div class="data-list-item add" @click.stop="$emit('add')">
            <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
                <font-awesome-icon
                    icon="clock"
                    class="card-body-icon"
                />
            </div>
        </div>

        <div v-if="results.length > 0" class="list-content result-table my-3">
            <vue3-datatable
                ref="resultTable"
                :rows="results"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                height="100%"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
                @row-click="emitEdit"
            >
                <template #tracked="row">
                    <font-awesome-icon v-if="row.value.tracked" class="row-icon" icon="map-marker"/>
                    <font-awesome-icon v-else  class="row-icon" icon="clock"
                    />
                </template>
            </vue3-datatable>
        </div>
    </div>

</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
export default {
    name: 'WorkTimeModeList',
    components: {Vue3Datatable},
    data() {
        return {
            fields: [
                {field: 'tracked', title: '', sort: false,  headerClass: 'routa-table-header', type: 'number'},
                {field: 'id', title: this.$t('common.id'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'name', title: this.$t('common.name'), sort: true,  headerClass: 'routa-table-header'}
            ]
        }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        },
    },
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        }
    }
}
</script>
